import { Outlet, useLocation, useParams } from 'react-router';
import { BStepper } from '../../../components/ui/generic';
import { useEffect, useState } from 'react';
import { useHeader } from '../../../context/HeaderContext';

const DashboardTunnel = () => {
  const { trainingId } = useParams();
  const location = useLocation();
  const { setTitle, setDescription } = useHeader();

  useEffect(() => {
    setDescription('Inscription');
  }, [setDescription]);
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    switch (location.pathname) {
      case `/inscription/informations/${trainingId}`:
        setCurrentStep(0);
        break;
      case `/inscription/eligibilite/${trainingId}`:
        setCurrentStep(1);
        break;
      case `/inscription/documents/${trainingId}`:
        setCurrentStep(2);
        break;
      case `/inscription/signature/${trainingId}`:
        setCurrentStep(3);
        break;
      default:
        setCurrentStep(4);
    }
  }, [location, trainingId]);
  return (
    <div className={`flex flex-col gap-4`}>
      <BStepper currentStep={currentStep} steps={['Informations', 'Éligibilité', 'Documents', 'Signature']} />
      <div className={'flex w-full justify-center'}>
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardTunnel;
